/// <reference types="urijs"/>
class Stat {
	public static intance:Stat = null;

	constructor(url:uri.URI, collectTimeout:number) {
		this._url = url;
		this._collectTimeout = collectTimeout;
	}

	private _url:uri.URI;
	private _collectTimeout:number;
	private _queue:Array<StatEvent> = new Array();
	private _timeout:any = NaN;
	private _loader:URLLoader = new URLLoader();

	public send(event:StatEvent):void {
		if (BuildProperties.online !== 'true') {
			return;
		}
		PandaConsole.here;
		if (!event.hasUniq('type')) {
			PandaConsole.errorUncritical(new PandaError('event has no type'));
		}
		if (!event.hasUniq('project')) {
			PandaConsole.errorUncritical(new PandaError('event has no project, type: ' + event.$getData()['type']));
		}
		if (!event.hasUniq('site')) {
			PandaConsole.errorUncritical(new PandaError('event has no site, type: ' + event.$getData()['type']));
		}
		//PandaConsole.logDebug('Stat::send', 'event.type', event.$getData()['type']);
		this._queue.push(event);
		this.scheduleSend();
	}

	private scheduleSend():void {
		//PandaConsole.logDebug('Stat::scheduleSend', 'timeout', this._timeout);
		if (isNaN(this._timeout)) {
			this._timeout = setTimeout(this.handler_collectTimeOutEnded, this._collectTimeout);
		}
	}

	private handler_collectTimeOutEnded = () => {
		//PandaConsole.logDebug('Stat::collectTimeOutEnded', 'timeout', this._timeout);
		this._timeout = NaN;
		if (this._loader.getLoading()) {
			//PandaConsole.logDebug('Stat::collectTimeOutEnded', 'this._loader.loading');
			this._loader.onComplete.addListener(this.handler_sendToServer);
		} else {
			//PandaConsole.logDebug('Stat::collectTimeOutEnded', 'sendToServer');
			this.handler_sendToServer();
		}
	}

	private handler_sendToServer = () => {
		PandaConsole.logDebug('Stat::sendToServer');
		this._loader.onComplete.removeListener(this.handler_sendToServer);
		let data:string = this.stringifyEvents();
		//PandaConsole.logInfo(JSON.stringify(this._queue.map(e=>e.$getData()), null, 4));
		this._queue.length = 0;
		let req = new URLRequest(this._url, 'POST', data);
		this._loader.load(req);
	}

	private stringifyEvents():string {
		return JSON.stringify(this._queue.map(e=>e.$getData()));
	}
}
